import React, {useEffect, useRef} from 'react'
import DynamicAdoptive from "../../Scripts/DynamicAdoptive";
import './Menu.css'

const Menu = () => {

  useEffect(() => {
    DynamicAdoptive()
  })

  const refToMenuBody = useRef(undefined)


  const onHandleMenuClick = event => {
    const $menuBody = refToMenuBody.current

    if (event.currentTarget.classList.contains('_active')) {
      event.currentTarget.classList.remove('_active')
      $menuBody.classList.remove('_active')
      document.querySelector('body').style.overflow = ''
    } else {
      event.currentTarget.classList.add('_active')
      $menuBody.classList.add('_active')
      document.querySelector('body').style.overflow = 'hidden'
    }
  }

  return (
    <header className='header'>
      <div className='header__container _container'>
        <div className='header__content'>
          <div className='header__column'>
            <div className="header__menu menu">
              <div
                onClick={onHandleMenuClick}
                className="menu__icon icon-menu">
                <span></span>
                <span></span>
                <span></span>
              </div>
              <nav ref={refToMenuBody} className="menu__body">
              </nav>
            </div>
          </div>
          <div className='header__column'>
            <ul data-da="menu__body,0,768" className='header__column_list'>
              <li className='Menu-primary'><a href='/'>UX/UI Design</a></li>
              <li><a href='/'>Usability Testing</a></li>
              <li><a href='/'>Blog</a></li>
            </ul>
          </div>
          <div className='header__column'>
            <div className='header__column_logo'>
              <a href='/'><img src='/images/menu/Vector.png' alt='Logo'/></a>
            </div>
          </div>
          <div className='header__column'>
            <ul data-da='menu__body,1,768' className='header__column_list'>
              <li><a href='/'>About us</a></li>
              <li><a href='/'>Contacts</a></li>
              <li className='Menu-primary Menu-decor'><a href='mailto:ilove@opium.pro'>ilove@opium.pro</a></li>
            </ul>
          </div>
        </div>
      </div>
    </header>
  )
}

export default Menu